/* joechia-style currency converter v5.1 — USD base, mobile-aware.
 * Desktop: dropdown in .m-header__desktop .m-header__right
 * Mobile: pill grid in .m-menu-customer__language-currency (drawer)
 */
(function () {
  'use strict';

  var SHOP_CURRENCY = 'USD';
  var STORAGE_KEY = 'jc_currency';
  var RATES_KEY = 'jc_rates_v5';
  var RATES_TTL = 6 * 60 * 60 * 1000;

  var CURRENCIES = {
    USD: { symbol: '$',    decimals: 2, label: 'USD' },
    EUR: { symbol: '€',    decimals: 2, label: 'EUR' },
    GBP: { symbol: '£',    decimals: 2, label: 'GBP' },
    JPY: { symbol: '¥',    decimals: 0, label: 'JPY' },
    AUD: { symbol: 'A$ ', decimals: 2, label: 'AUD' },
    SGD: { symbol: 'S$ ', decimals: 2, label: 'SGD' },
    CNY: { symbol: '¥',    decimals: 2, label: 'CNY' },
    THB: { symbol: '฿',    decimals: 0, label: 'THB' },
    IDR: { symbol: 'Rp ', decimals: 0, label: 'IDR' },
    KRW: { symbol: '₩',    decimals: 0, label: 'KRW' }
  };

  function loadCachedRates() {
    try {
      var raw = localStorage.getItem(RATES_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.fetched || (Date.now() - data.fetched > RATES_TTL)) return null;
      return data.rates;
    } catch (e) { return null; }
  }
  function saveRates(rates) {
    try { localStorage.setItem(RATES_KEY, JSON.stringify({ fetched: Date.now(), rates: rates })); } catch (e) {}
  }
  function fetchAndCacheRates() {
    fetch('https://open.er-api.com/v6/latest/USD')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j && j.rates) { j.rates.USD = 1; saveRates(j.rates); } })
      .catch(function () {});
  }
  function getRatesSync() {
    return loadCachedRates() || { USD: 1, EUR: 0.92, GBP: 0.79, JPY: 157, AUD: 1.55, SGD: 1.34, CNY: 7.25, THB: 33.5, IDR: 16300, KRW: 1360 };
  }
  function getCurrent() { try { return localStorage.getItem(STORAGE_KEY) || SHOP_CURRENCY; } catch (e) { return SHOP_CURRENCY; } }
  function setCurrent(code) { try { localStorage.setItem(STORAGE_KEY, code); } catch (e) {} }

  function parseUSD(text) {
    if (!text) return null;
    var m = text.match(/\$\s*([\d,]+(?:\.\d{0,2})?)/);
    if (!m) return null;
    var n = parseFloat(m[1].replace(/,/g, ''));
    return isFinite(n) && n > 0 ? n : null;
  }

  function formatPrice(amount, code) {
    var c = CURRENCIES[code] || CURRENCIES[SHOP_CURRENCY];
    var n = c.decimals === 0 ? Math.round(amount) : Math.round(amount * 100) / 100;
    return c.symbol + n.toLocaleString('en-US', { minimumFractionDigits: c.decimals, maximumFractionDigits: c.decimals });
  }

  function convertPrices(targetCode) {
    var rates = getRatesSync();
    var rate = rates[targetCode] || 1;
    var nodes = document.querySelectorAll('.m-price-item, .money, [data-product-price]');
    for (var k = 0; k < nodes.length; k++) {
      var el = nodes[k];
      var origUsd = el.dataset.jcUsd;
      if (!origUsd) {
        var amount = parseUSD(el.textContent);
        if (amount === null) continue;
        origUsd = String(amount);
        el.dataset.jcUsd = origUsd;
      }
      var amt = parseFloat(origUsd);
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var node, first = null;
      while ((node = walker.nextNode())) { if (node.nodeValue && /\S/.test(node.nodeValue)) { first = node; break; } }
      if (first) first.nodeValue = formatPrice(amt * rate, targetCode);
      while ((node = walker.nextNode())) { if (node.nodeValue && /\d/.test(node.nodeValue)) node.nodeValue = ''; }
    }
  }

  function syncAllDropdowns(code) {
    // Desktop dropdown: update label + active state
    document.querySelectorAll('.jc-currency-switcher:not(.jc-currency-mobile) .jc-currency-label').forEach(function (l) {
      l.textContent = CURRENCIES[code] ? CURRENCIES[code].label : code;
    });
    document.querySelectorAll('.jc-currency-switcher:not(.jc-currency-mobile) li[data-code]').forEach(function (li) {
      var active = li.getAttribute('data-code') === code;
      li.style.fontWeight = active ? '600' : '';
      li.style.opacity = active ? '1' : '0.65';
    });
    // Mobile pill grid: update active pill styles
    document.querySelectorAll('.jc-currency-mobile button[data-code]').forEach(function (btn) {
      var active = btn.getAttribute('data-code') === code;
      btn.style.background = active ? '#020202' : 'transparent';
      btn.style.color = active ? '#fff' : '#444';
      btn.style.borderColor = active ? '#020202' : 'rgba(0,0,0,0.18)';
    });
  }

  function handleChange(code) {
    setCurrent(code);
    convertPrices(code);
    syncAllDropdowns(code);
  }

  /* ---- Desktop dropdown ---- */
  function createDesktopDropdown(current) {
    var wrap = document.createElement('div');
    wrap.className = 'jc-currency-switcher';
    wrap.style.cssText = 'position:relative;display:inline-flex;align-items:center;margin-right:12px;cursor:pointer;user-select:none;vertical-align:middle;';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.style.cssText = 'background:none;border:none;color:inherit;font:inherit;cursor:pointer;padding:2px 4px;display:inline-flex;align-items:center;gap:4px;letter-spacing:0.08em;font-size:13px;opacity:0.85;font-family:"Barlow",sans-serif;';
    trigger.innerHTML = '<span class="jc-currency-label">' + (CURRENCIES[current] ? CURRENCIES[current].label : current) + '</span><span class="jc-caret" style="font-size:8px;opacity:0.6;transition:transform 0.2s;">▾</span>';

    var list = document.createElement('ul');
    list.setAttribute('role', 'listbox');
    list.style.cssText = 'position:absolute;top:calc(100% + 6px);right:0;margin:0;padding:6px 0;list-style:none;background:#fff;color:#020202;border:1px solid #ebebeb;min-width:90px;box-shadow:0 8px 24px rgba(0,0,0,0.1);opacity:0;visibility:hidden;transform:translateY(-4px);transition:opacity 0.18s ease,transform 0.18s ease,visibility 0.18s;z-index:9999;';

    Object.keys(CURRENCIES).forEach(function (code) {
      var li = document.createElement('li');
      li.setAttribute('data-code', code);
      var isActive = code === current;
      li.style.cssText = 'padding:7px 14px;cursor:pointer;font-size:12px;letter-spacing:0.08em;font-family:"Barlow",sans-serif;' + (isActive ? 'font-weight:600;' : 'opacity:0.65;');
      li.textContent = code;
      li.addEventListener('mouseenter', function () { li.style.background = '#f5f5f5'; });
      li.addEventListener('mouseleave', function () { li.style.background = ''; });
      li.addEventListener('click', function (e) { e.stopPropagation(); handleChange(code); closeDd(); });
      list.appendChild(li);
    });

    function openDd() { list.style.opacity='1';list.style.visibility='visible';list.style.transform='translateY(0)';trigger.setAttribute('aria-expanded','true');var c=trigger.querySelector('.jc-caret');if(c)c.style.transform='rotate(180deg)'; }
    function closeDd() { list.style.opacity='0';list.style.visibility='hidden';list.style.transform='translateY(-4px)';trigger.setAttribute('aria-expanded','false');var c=trigger.querySelector('.jc-caret');if(c)c.style.transform=''; }
    trigger.addEventListener('click', function (e) { e.stopPropagation(); list.style.visibility==='visible' ? closeDd() : openDd(); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) closeDd(); });

    wrap.appendChild(trigger);
    wrap.appendChild(list);
    return wrap;
  }

  /* ---- Mobile pill grid ---- */
  function createMobilePills(current) {
    var wrap = document.createElement('div');
    wrap.className = 'jc-currency-switcher jc-currency-mobile';
    wrap.style.cssText = 'display:flex;flex-wrap:wrap;gap:6px;padding:10px 0 16px;width:100%;';

    Object.keys(CURRENCIES).forEach(function (code) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('data-code', code);
      btn.textContent = code;
      var isActive = code === current;
      btn.style.cssText = 'background:' + (isActive ? '#020202' : 'transparent') + ';color:' + (isActive ? '#fff' : '#444') + ';border:1px solid ' + (isActive ? '#020202' : 'rgba(0,0,0,0.18)') + ';font:300 11px/1 "Barlow",sans-serif;letter-spacing:0.7px;text-transform:uppercase;padding:7px 10px;cursor:pointer;border-radius:0;transition:background 0.2s,color 0.2s,border-color 0.2s;min-width:42px;text-align:center;';
      btn.addEventListener('click', function () { handleChange(code); });
      wrap.appendChild(btn);
    });
    return wrap;
  }

  function inject() {
    var current = getCurrent();

    // Desktop: inject dropdown into header right section
    document.querySelectorAll('.m-header__desktop .m-header__right').forEach(function (el) {
      if (el.querySelector('.jc-currency-switcher')) return;
      el.insertBefore(createDesktopDropdown(current), el.firstChild);
    });

    // Mobile: inject pill grid into menu drawer customer section
    document.querySelectorAll('.m-menu-customer__language-currency').forEach(function (el) {
      if (el.querySelector('.jc-currency-mobile')) return;
      el.insertBefore(createMobilePills(current), el.firstChild);
    });
  }

  function init() {
    if (!loadCachedRates()) fetchAndCacheRates();
    inject();
    var current = getCurrent();
    if (current !== SHOP_CURRENCY) {
      setTimeout(function () { convertPrices(current); }, 600);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
